import { render, staticRenderFns } from "./ModifyTable.vue?vue&type=template&id=297ca5e1"
import script from "./ModifyTable.vue?vue&type=script&lang=js"
export * from "./ModifyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports